import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SnackbarContainer } from 'components/standalone';
import { extractErrorMessage } from 'utils';
import { ModelContainer } from '../containers/useModelContainer';
import { ModelForm, ModelFormValues } from '../components/ModelForm';
import { toModelPayload } from '../modelPayload';

const ModelCreateInner = () => {
  const classes = useStyles();
  const history = useHistory();
  const { notify } = SnackbarContainer.useContainer();

  const { formLoading, createModel, searchBuilders, loadSubdivisions } =
    ModelContainer.useContainer();

  const handleGoBack = useCallback(() => {
    history.push('/model');
  }, [history]);

  const handleSubmit = useCallback(
    async (values: ModelFormValues) => {
      try {
        const model = await createModel(toModelPayload(values));
        notify('Element created');
        history.push(`/model/${model.id}`);
      } catch (error) {
        notify(extractErrorMessage(error, 'Failed to create model'), 'error');
      }
    },
    [createModel, history, notify],
  );

  const handleLoadSubdivisions = useCallback(
    async (builderId: string, search: string) => {
      return loadSubdivisions(builderId, search);
    },
    [loadSubdivisions],
  );

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <ModelForm
            mode="create"
            onSubmit={handleSubmit}
            loading={formLoading}
            loadBuilders={searchBuilders}
            loadSubdivisions={handleLoadSubdivisions}
            onGoBack={handleGoBack}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '1500px',
  },
  card: {
    position: 'relative',
  },
  cardContent: {
    padding: 0,
    paddingBottom: '0 !important',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

export const ModelCreate = () => {
  return (
    <ModelContainer.Provider>
      <ModelCreateInner />
    </ModelContainer.Provider>
  );
};

export default ModelCreate;
